module.exports = __webpack_public_path__ + "img/sherrer-paineis-1.667e3752.jpeg";